import * as Stickyfill from 'stickyfilljs';
import 'url-polyfill';
import 'focus-within-polyfill';

/**
 * Pollyfill Date for Safari and IE
 */
function polyfillDateForSafariAndIE() {
  // Safari and IE can not parse Date strings with timezone information without colon (i.e. +0100)
  if (Number.isNaN(new Date('1900-01-01T00:00:00.000+0000').getTime())) {
    try {
      /* eslint-disable @typescript-eslint/ban-ts-comment */
      // @ts-ignore
      window._Date = window.Date;
      // @ts-ignore
      window.Date = function(...args: any[]) {
        if (args.length === 1 && typeof args[0] === 'string') {
          // @ts-ignore
          return new window._Date(args[0].replace(/(\+)([0-9]{2})([0-9]{2})$/, '$1$2:$3'));
        }

        // @ts-ignore
        return new window._Date(...args);
      };
      // @ts-ignore
      Object.getOwnPropertyNames(window._Date).forEach(name => {
        // IE dislikes accessing caller and arguments, Chrome dislikes length and name
        if (name !== 'length' && name !== 'name' && name !== 'caller' && name !== 'arguments') {
          // @ts-ignore
          window.Date[name] = window._Date[name];
        }
      });

      // @ts-ignore
      Date._parse = Date.parse;
      Date.parse = function(d) {
        // @ts-ignore
        return Date._parse(typeof d === 'string' ? d.replace(/\+0000$/, 'Z') : d);
      };
    } catch (e) {
      console.error('Failed to polyfill Date', e);
    }
  }
}

polyfillDateForSafariAndIE();

export const initPolyfills = (): void => {
  // position: sticky polyfill
  const stickyElements = $('#header-container, #sidebar');
  Stickyfill.add(stickyElements);
};
